import React from 'react';
import PropTypes from 'prop-types';

/**
 * catches render errors inside protected content and invokes onError (e.g. logout)
 * to prevent a silent blank page
 */
export class AuthErrorBoundary extends React.Component {
    state = { hasError: false };

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error) {
        console.error('AuthErrorBoundary caught a render error:', error);
        this.props.onError?.();
    }

    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
}

AuthErrorBoundary.propTypes = {
    children: PropTypes.node,
    onError: PropTypes.func
};
